//hooks/useAuth.js
import { useSelector } from 'react-redux'
import { selectCurrentToken } from "../features/auth/authSlice"
import jwtDecode from 'jwt-decode'
import { useState, useEffect } from 'react'

const useAuth = () => {
    const token = useSelector(selectCurrentToken)
    const [isLoading, setIsLoading] = useState(true)
    const [authData, setAuthData] = useState({
        username: '',
        roles: [],
        isAdmin: false,
        status: 'Sale',
        userId: null
    })

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token)
                const { username, roles, id } = decoded.UserInfo

                const isAdmin = roles.includes('Admin')
                const status = isAdmin ? 'Admin' : 'Sale'

                setAuthData({
                    username,
                    roles,
                    isAdmin,
                    status,
                    userId: id
                })
            } catch (err) {
                console.error('JWT decode error:', err)
                setAuthData({
                    username: '',
                    roles: [],
                    isAdmin: false,
                    status: 'Sale',
                    userId: null
                })
            }
        } else {
            setAuthData({
                username: '',
                roles: [],
                isAdmin: false,
                status: 'Sale',
                userId: null
            })
        }
        setIsLoading(false)
    }, [token])

    return { ...authData, isLoading }
}

export default useAuth